<template>
  <div class="nav">
    <v-navigation-drawer
      v-model="drawer"
      location="right"
      temporary
      sticky
      :style="{ width: getWidth }"
      :id="uniqueID"
      style="
        font-size: larger;
        background-color: rgb(var(--v-theme-drawer));
        overscroll-behavior: contain;
      "
      :class="{ 'pa-6 pt-0': !isMobile, 'pt-0': isMobile }"
    >
      <v-btn
        flat
        icon
        class="iconButton"
        style="
          background-color: rgb(var(--v-theme-drawer)) !important;
          position: absolute;
          top: 16px;
          right: 10px;
          z-index: 999;
        "
        @click="this.drawer = false"
        ><v-icon>mdi-close</v-icon></v-btn
      >
      <div class="mt-11">
        <slot />
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "baseDrawer",

  props: ["refreshDisplay", "scale"],

  data() {
    return {
      drawer: false,
      idNumber: Math.floor(Math.random() * 10000000000),
    };
  },

  watch: {
    refreshDisplay() {
      if (this.refreshDisplay) {
        this.drawer = true;
        document
          .getElementById(this.uniqueID)
          .getElementsByClassName("v-navigation-drawer__content")[0]
          .scrollTo(0, 0);
      } else {
        this.drawer = false;
      }
    },
    drawer() {
      const app = document.getElementById("app");

      if (!this.drawer) {
        app.classList.remove("no-scroll");
      } else {
        app.classList.add("no-scroll");
      }
    },
  },

  computed: {
    uniqueID() {
      return btoa(this.$route.name) + this.idNumber;
    },
    getWidth() {
      let scale = this.scale ? this.scale : 1;

      switch (this.$vuetify.display.name) {
        case "xs":
          return 100 * scale + "vw";
        case "sm":
          return 100 * scale + "vw";
        case "md":
          return 50 * scale + "vw";
        case "lg":
          return 40 * scale + "vw";
        case "xl":
          return 30 * scale + "vw";
        case "xxl":
          return 25 * scale + "vw";
        default:
          return 30 * scale + "vw";
      }
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
  },
};
</script>
